import React from 'react';
import styled from 'styled-components';
import { DataGrid } from '../../../ui-toolkit';
import SpruceIcon from '../../../ui-toolkit/images/spruce-icon-big.png';

export const SpruceIconSmall = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: block;
`;

export const OrderIdWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0;
`;

interface SpruceOrderRowData {
  isSpruce: boolean;
}

export const getSpruceRowClasses = <T extends SpruceOrderRowData>(
  row: T,
  rowIndex: number,
  isZillowClosingEnabled: boolean
): string => {
  if (isZillowClosingEnabled && row.isSpruce) {
    return 'spruce-order-row';
  }
  return '';
};

export const StyledSpruceDataGrid = styled(DataGrid)`
  tbody tr.spruce-order-row {
    &:hover {
      background-color: #d1f2eb;
    }
  }

  tbody tr.spruce-order-row:hover td {
    background-color: #d1f2eb;
  }
` as typeof DataGrid;

interface SpruceOrderIdProps {
  fileNumber: string;
  showIcon: boolean;
}

export const SpruceOrderId: React.FC<SpruceOrderIdProps> = ({ fileNumber, showIcon }) => {
  return (
    <OrderIdWrapper>
      {showIcon && <SpruceIconSmall src={SpruceIcon} alt="Spruce order" />}
      {fileNumber}
    </OrderIdWrapper>
  );
};
